import React from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from "@date-io/date-fns";
import { ApplyOnline } from './pages/applyOnline/ApplyOnline';
import { UserContext } from "./context/user";
import { loadCurrentUser } from "./api/auth";
import { ApplicationPage } from "./pages/applicationPage/ApplicationPage";
import { ApplicationHistoryPage } from "./pages/applicationHistory/ApplicationHistory";
import { AgencyConfigPage } from "./pages/agencyConfig/AgencyConfig";
import { AgencyProfilePage } from "./pages/agencyProfile/AgencyProfile";
import { SalesAgenciesPage } from "./pages/salesAgencies/SalesAgencies";

class App extends React.PureComponent {
  state = {
    user: null,
  };

  componentDidMount() {
    this.loadUserInfo();
  }

  loadUserInfo = async () => {
    const user = await loadCurrentUser();
    this.setState({ user });
  };

  render() {
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Router basename="/">
          <UserContext.Provider value={this.state.user}>
            <Route path='/apasi-members' component={ApplicationHistoryPage}/>
            <Route path='/apasi-profile' component={AgencyProfilePage}/>
            <Route path='/apasi-agency-config' component={AgencyConfigPage}/>
            <Route path='/apply-online' component={ApplyOnline}/>
            <Route path='/sales-network' component={SalesAgenciesPage}/>
            <Route path='/applications/:id' component={ApplicationPage}/>
          </UserContext.Provider>
        </Router>
      </MuiPickersUtilsProvider>
    );
  }
}

export default App;
